import React from 'react'
import { Link } from 'react-router-dom'
import { Button, FullBlockLoader, CircleLoader } from '@deal/components'
import ContentfulQuery from '#src/containers/Contentful'
import { CategoryInfoFragment, DepartmentTopLevelCategoryFragment } from '#src/generated/graphql'
import {
  generateCreateUrlFromCategory,
  generateCreateUrl,
  getOnboardingPathSlug
} from '#src/services/path'
import styles from './styles.css'

interface NoLeadProps {
  departmentSlug: string
  topLevelCategory: CategoryInfoFragment | DepartmentTopLevelCategoryFragment | null
  isDepartmentInactive: boolean
}

const NoLead: React.SFC<NoLeadProps> = ({
  topLevelCategory,
  departmentSlug,
  isDepartmentInactive
}) => {
  if (!topLevelCategory || !topLevelCategory.contentAssets) {
    return null
  }

  const actionUrl = topLevelCategory.slug
    ? generateCreateUrlFromCategory(topLevelCategory.slug)
    : generateCreateUrl(getOnboardingPathSlug())

  return (
    <div
      className={styles.header}
      style={{
        backgroundImage: `url('${topLevelCategory &&
          topLevelCategory.contentAssets.communityPoster &&
          `${topLevelCategory.contentAssets.communityPoster.imageUrl}?auto=compress%2Cformat`}')`
      }}
    >
      <ContentfulQuery template="loggedInHomeHero" variation={departmentSlug}>
        {({ loading, content }) => {
          if (loading) {
            return <FullBlockLoader loader={CircleLoader} />
          } else if (!content) {
            return (
              <>
                <div className={styles.welcomeHeader}>let us work for you</div>
                <div className={styles.pageHeader}>
                  Shop with an expert. Find something you love.
                </div>

                {!isDepartmentInactive && (
                  <div className={styles.action}>
                    <Link to={actionUrl}>
                      <Button size="large">Get started</Button>
                    </Link>
                  </div>
                )}
              </>
            )
          }

          return (
            <>
              <div className={styles.welcomeHeader}>{content.subtitle}</div>
              <div className={styles.pageHeader}>{content.title}</div>

              {!isDepartmentInactive && (
                <div className={styles.action}>
                  <Link to={actionUrl}>
                    <Button size="large">{content.buttonText || 'Get Started'}</Button>
                  </Link>
                </div>
              )}
            </>
          )
        }}
      </ContentfulQuery>
    </div>
  )
}

export default NoLead
